export var SurveyAccountConfigurationTypes;
(function (SurveyAccountConfigurationTypes) {
    SurveyAccountConfigurationTypes["String"] = "string";
    SurveyAccountConfigurationTypes["Number"] = "number";
    SurveyAccountConfigurationTypes["Url"] = "url";
    SurveyAccountConfigurationTypes["Boolean"] = "boolean";
})(SurveyAccountConfigurationTypes || (SurveyAccountConfigurationTypes = {}));
export var Theme;
(function (Theme) {
    Theme["Chatbot"] = "chatbot";
    Theme["Default"] = "default";
    Theme["VirtualCare"] = "virtualCare";
})(Theme || (Theme = {}));
